import React from 'react';
import { Box, IconButton, Chip } from '@mui/material';
import SideBarLogo from '../../../assets/backrr_logo.png';

const SidebarHeader = ({
  sidebarCollapsed,
  matchesUpMd,
  toggleDrawer,
  navigate,
}) => {
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        px: '0rem',
        mt: { xs: '0.5rem', md: '1.5rem' },
        mb: { xs: '1.5rem', md: '2.5rem' },
        flexShrink: 0,
      }}
    >
      {!sidebarCollapsed ? (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            gap: '0.5rem',
            flex: 1,
            minWidth: 0,
            cursor: 'pointer',
            height: '1rem',
            padding: '0.5rem 1.2rem',
            marginTop: '0.75rem',
          }}
          onClick={() => {
            navigate('/');
            toggleDrawer();
          }}
        >
          <img
            src={SideBarLogo}
            alt="Backrr"
            style={{
              height: '2rem',
              width: 'auto',
              objectFit: 'contain',
              flexShrink: 0,
              filter: 'invert(1)',
            }}
          />
          <Chip
            label="Admin"
            size="small"
            sx={{
              color: 'rgba(255,255,255,0.85)',
              border: '1px solid rgba(255,255,255,0.25)',
              backgroundColor: 'transparent',
              fontWeight: 'bold',
              fontSize: '0.6875rem',
              height: '1.25rem',
              borderRadius: '6px',
              '& > .MuiChip-label': {
                paddingInline: '0.375rem',
                textOverflow: 'clip',
              },
            }}
          />
        </Box>
      ) : (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'center',
            width: '100%',
            cursor: 'pointer',
          }}
          onClick={() => {
            navigate('/');
            toggleDrawer();
          }}
        >
          <img
            src={SideBarLogo}
            alt="Backrr"
            style={{ height: '1.5rem', width: 'auto', filter: 'invert(1)' }}
          />
        </Box>
      )}

      {!matchesUpMd && (
        <IconButton
          onClick={toggleDrawer}
          sx={{
            color: 'rgba(255,255,255,0.7)',
            p: '0.25rem',
            ml: '0.25rem',
            marginRight: '1rem',
            marginTop: '0.5rem',
          }}
        >
          ✕
        </IconButton>
      )}
    </Box>
  );
};

export default SidebarHeader;
